import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { MspInProductTrialsOverlayContentController } from '../controller/MspInProductTrialsOverlayContentController';
import { MspInProductTrialsOverlayWindowType } from '../../mspInProductTrialsOverlaysApp/types/MspInProductTrialsOverlayWindowType';

export class MspInProductTrialsOverlayContentWebComponent extends BaseWebComponentElement {
  public controller!: MspInProductTrialsOverlayContentController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MspInProductTrialsOverlayContentController,
    });
  }

  public get mspInProductTrialsOverlayWindowType(): MspInProductTrialsOverlayWindowType {
    const mspInProductTrialsOverlayWindowType = this.getAttribute('mspInProductTrialsOverlayWindowType');

    return mspInProductTrialsOverlayWindowType
      ? (mspInProductTrialsOverlayWindowType as MspInProductTrialsOverlayWindowType)
      : MspInProductTrialsOverlayWindowType.menuOverlay;
  }
}
